import { combineReducers }    from 'redux-immutable';
import buildIdsByPageReducer  from './buildIdsByPageReducer';
import buildPageCountsReducer from './buildPageCountsReducer';


export const RESOURCE_IDE_BY_PAGE_STATE = 'idsByPage';

export const RESOURCE_PAGE_COUNTS_STATE = 'pageCounts';


/**
 * Builds 'list' reducers for a given resource
 *
 * @param {string} resource
 */

const buildAllListReducers = (resource) => combineReducers({
  [RESOURCE_IDE_BY_PAGE_STATE]: buildIdsByPageReducer(resource),
  [RESOURCE_PAGE_COUNTS_STATE]: buildPageCountsReducer(resource),
});


export default buildAllListReducers;


// WEBPACK FOOTER //
// ./src/reducers/utils/apiResources/list/buildAllListReducers.js